import React from 'react';
import { DynamicBreadcrumb } from '@/components/navigation/DynamicBreadcrumb';
import { cn } from '@/lib/utils';
interface PageHeaderProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  showBreadcrumb?: boolean;
  className?: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  title,
  description,
  children,
  showBreadcrumb = true,
  className = '',
  actions
}: PageHeaderProps) {
  return <div className={cn('space-y-4 pb-6', className)}>
      {showBreadcrumb && <DynamicBreadcrumb />}
      
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
          {title && <h1 className="font-bold tracking-tight text-foreground text-sm">
              {title}
            </h1>}
          {description}
        </div>
        
        {actions && <div className="flex items-center gap-2">
            {actions}
          </div>}
      </div>
      
      {children}
    </div>;
}